import { PATHS } from '@client/paths';
import { Typography } from '@design-system/components/typography/typography';
import { sprinkles } from '@design-system/sprinkles.css';
import { Link } from '@client/router/compat';
import { clsx } from 'clsx';

export const SubscriptionLPLink = ({
  programId,
  creatorId,
}: {
  programId: number;
  creatorId: number;
}) => (
  <Typography variant="body">
    <Link
      className={clsx('underline', sprinkles({ color: 'P-80' }))}
      to={PATHS.PROGRAM_EDIT(programId, creatorId, 'sales-page')}
    >
      Customize
    </Link>{' '}
    your Landing page to boost your sales.
  </Typography>
);
